export default "__VITE_ASSET__CSGnv9p3__"